<template>
  <div class="sub-title">
    <h3>{{text}}</h3>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PageSubTitle',
  props: ['text']
}
</script>

<style scoped>
.sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #27273f;
  height: 32px;
  position: relative;
  border-bottom: 2px solid #f2f2fa;
  padding-bottom:15px;
  display:flex;
}
.sub-title > h3 {
  display: flex;
  height: 100%;
  align-items: center;
  width: 180px;
  font-size: 13px;
  font-weight: bold;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
}
</style>
